import { defineComponent as $, openBlock as a, createElementBlock as l, mergeProps as T, createCommentVNode as _, renderSlot as U, useId as N, unref as V, createTextVNode as z, toDisplayString as u, createElementVNode as d, normalizeClass as C, ref as I, computed as P, Fragment as B, renderList as M, createBlock as S, resolveDynamicComponent as G, withDirectives as ae, vModelText as le, watch as Y, normalizeStyle as O, withModifiers as J, onBeforeUnmount as D, Teleport as H, createVNode as q, Transition as oe, withCtx as L, h as j, onMounted as Q, nextTick as W } from "vue";
const ie = ["type", "disabled"], se = {
  key: 0,
  class: "ui-btn__spinner",
  "aria-hidden": "true"
}, ne = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "UiButton",
  props: {
    variant: { default: "primary" },
    type: { default: "button" },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    block: { type: Boolean, default: !1 }
  },
  setup(o) {
    const t = o;
    return (e, i) => (a(), l("button", T({
      type: t.type,
      disabled: t.disabled || t.loading,
      class: [
        "ui-btn",
        `ui-btn--${t.variant}`,
        { "ui-btn--block": t.block, "ui-btn--loading": t.loading }
      ]
    }, e.$attrs), [
      t.loading ? (a(), l("span", se)) : _("", !0),
      U(e.$slots, "default", {}, void 0, !0)
    ], 16, ie));
  }
}), k = (o, t) => {
  const e = o.__vccOpts || o;
  for (const [i, p] of t)
    e[i] = p;
  return e;
}, F = /* @__PURE__ */ k(ne, [["__scopeId", "data-v-486a8fea"]]), re = { class: "ui-input" }, ue = ["for"], de = {
  key: 0,
  class: "ui-input__required",
  "aria-hidden": "true"
}, ce = ["id", "type", "value", "placeholder", "disabled", "required", "aria-invalid", "aria-describedby"], _e = ["id"], pe = ["id"], he = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "UiInput",
  props: {
    modelValue: { default: "" },
    label: {},
    placeholder: {},
    type: { default: "text" },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    error: {},
    hint: {},
    id: {}
  },
  emits: ["update:modelValue", "blur", "focus"],
  setup(o, { emit: t }) {
    const e = o, i = t, p = N(), n = e.id ?? p;
    function s(r) {
      i("update:modelValue", r.target.value);
    }
    return (r, c) => (a(), l("div", re, [
      e.label ? (a(), l("label", {
        key: 0,
        for: V(n),
        class: "ui-input__label"
      }, [
        z(u(e.label) + " ", 1),
        e.required ? (a(), l("span", de, "*")) : _("", !0)
      ], 8, ue)) : _("", !0),
      d("input", T({
        id: V(n),
        type: e.type,
        value: e.modelValue,
        placeholder: e.placeholder,
        disabled: e.disabled,
        required: e.required,
        "aria-invalid": !!e.error,
        "aria-describedby": e.error ? `${V(n)}-error` : e.hint ? `${V(n)}-hint` : void 0,
        class: ["ui-input__field", { "ui-input__field--error": !!e.error }]
      }, r.$attrs, {
        onInput: s,
        onBlur: c[0] || (c[0] = (h) => i("blur", h)),
        onFocus: c[1] || (c[1] = (h) => i("focus", h))
      }), null, 16, ce),
      e.error ? (a(), l("span", {
        key: 1,
        id: `${V(n)}-error`,
        class: "ui-input__error",
        role: "alert"
      }, u(e.error), 9, _e)) : e.hint ? (a(), l("span", {
        key: 2,
        id: `${V(n)}-hint`,
        class: "ui-input__hint"
      }, u(e.hint), 9, pe)) : _("", !0)
    ]));
  }
}), Ta = /* @__PURE__ */ k(he, [["__scopeId", "data-v-970c68ba"]]), fe = { class: "ui-textarea" }, me = ["for"], ve = {
  key: 0,
  class: "ui-textarea__required",
  "aria-hidden": "true"
}, be = ["id", "value", "placeholder", "disabled", "required", "rows", "maxlength", "aria-invalid"], ye = { class: "ui-textarea__meta" }, ge = {
  key: 0,
  class: "ui-textarea__error",
  role: "alert"
}, $e = {
  key: 1,
  class: "ui-textarea__hint"
}, ke = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "UiTextarea",
  props: {
    modelValue: { default: "" },
    label: {},
    placeholder: {},
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    error: {},
    hint: {},
    rows: { default: 4 },
    maxLength: {},
    id: {}
  },
  emits: ["update:modelValue", "blur"],
  setup(o, { emit: t }) {
    const e = o, i = t, p = N(), n = e.id ?? p;
    function s(r) {
      i("update:modelValue", r.target.value);
    }
    return (r, c) => (a(), l("div", fe, [
      e.label ? (a(), l("label", {
        key: 0,
        for: V(n),
        class: "ui-textarea__label"
      }, [
        z(u(e.label) + " ", 1),
        e.required ? (a(), l("span", ve, "*")) : _("", !0)
      ], 8, me)) : _("", !0),
      d("textarea", T({
        id: V(n),
        value: e.modelValue,
        placeholder: e.placeholder,
        disabled: e.disabled,
        required: e.required,
        rows: e.rows,
        maxlength: e.maxLength,
        "aria-invalid": !!e.error,
        class: ["ui-textarea__field", { "ui-textarea__field--error": !!e.error }]
      }, r.$attrs, {
        onInput: s,
        onBlur: c[0] || (c[0] = (h) => i("blur", h))
      }), null, 16, be),
      d("div", ye, [
        e.error ? (a(), l("span", ge, u(e.error), 1)) : e.hint ? (a(), l("span", $e, u(e.hint), 1)) : _("", !0),
        e.maxLength ? (a(), l("span", {
          key: 2,
          class: C(["ui-textarea__counter", { "ui-textarea__counter--warn": e.modelValue.length > e.maxLength * 0.9 }])
        }, u(e.modelValue.length) + " / " + u(e.maxLength), 3)) : _("", !0)
      ])
    ]));
  }
}), Na = /* @__PURE__ */ k(ke, [["__scopeId", "data-v-6efb30ed"]]), we = { class: "ui-file" }, Ce = ["for"], xe = {
  key: 0,
  class: "ui-file__required",
  "aria-hidden": "true"
}, Ie = ["id", "accept", "disabled", "required", "aria-invalid"], Ue = ["disabled"], Ve = ["title"], Be = {
  key: 1,
  class: "ui-file__placeholder"
}, Le = {
  key: 1,
  class: "ui-file__error",
  role: "alert"
}, ze = {
  key: 2,
  class: "ui-file__hint"
}, Ee = {
  key: 3,
  class: "ui-file__hint"
}, Me = /* @__PURE__ */ $({
  __name: "UiFileInput",
  props: {
    modelValue: { default: null },
    label: {},
    accept: {},
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    error: {},
    hint: {},
    currentName: {},
    buttonLabel: { default: "Выбрать файл" },
    id: {}
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, i = t, p = N(), n = e.id ?? p, s = I(null), r = P(() => {
      var f;
      return ((f = e.modelValue) == null ? void 0 : f.name) ?? null;
    });
    function c() {
      var f;
      (f = s.value) == null || f.click();
    }
    function h(f) {
      var b;
      const x = ((b = f.target.files) == null ? void 0 : b[0]) ?? null;
      i("update:modelValue", x);
    }
    function v() {
      s.value && (s.value.value = ""), i("update:modelValue", null);
    }
    return (f, x) => (a(), l("div", we, [
      e.label ? (a(), l("label", {
        key: 0,
        for: V(n),
        class: "ui-file__label"
      }, [
        z(u(e.label) + " ", 1),
        e.required ? (a(), l("span", xe, "*")) : _("", !0)
      ], 8, Ce)) : _("", !0),
      d("input", {
        id: V(n),
        ref_key: "inputRef",
        ref: s,
        type: "file",
        class: "ui-file__native",
        accept: e.accept,
        disabled: e.disabled,
        required: e.required,
        "aria-invalid": !!e.error,
        onChange: h
      }, null, 40, Ie),
      d("div", {
        class: C(["ui-file__control", { "ui-file__control--error": !!e.error }])
      }, [
        d("button", {
          type: "button",
          class: "ui-file__btn",
          disabled: e.disabled,
          onClick: c
        }, u(e.buttonLabel), 9, Ue),
        r.value ? (a(), l("span", {
          key: 0,
          class: "ui-file__name",
          title: r.value
        }, u(r.value), 9, Ve)) : (a(), l("span", Be, "Файл не выбран")),
        e.modelValue ? (a(), l("button", {
          key: 2,
          type: "button",
          class: "ui-file__clear",
          "aria-label": "Убрать файл",
          onClick: v
        }, " × ")) : _("", !0)
      ], 2),
      e.error ? (a(), l("span", Le, u(e.error), 1)) : e.currentName && !e.modelValue ? (a(), l("span", ze, " Текущий файл: " + u(e.currentName), 1)) : e.hint ? (a(), l("span", Ee, u(e.hint), 1)) : _("", !0)
    ]));
  }
}), ja = /* @__PURE__ */ k(Me, [["__scopeId", "data-v-a2666e3f"]]), qe = { class: "ui-select" }, Se = ["for"], Pe = {
  key: 0,
  class: "ui-select__required",
  "aria-hidden": "true"
}, Oe = { class: "ui-select__wrap" }, Ae = ["id", "value", "disabled", "required", "aria-invalid"], Re = {
  key: 0,
  value: "",
  disabled: ""
}, Fe = ["label"], Te = ["value", "disabled"], Ne = ["value", "disabled"], je = {
  key: 1,
  class: "ui-select__error",
  role: "alert"
}, De = {
  key: 2,
  class: "ui-select__hint"
}, He = /* @__PURE__ */ $({
  inheritAttrs: !1,
  __name: "UiSelect",
  props: {
    modelValue: {},
    options: {},
    label: {},
    placeholder: {},
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    error: {},
    hint: {},
    id: {}
  },
  emits: ["update:modelValue", "change"],
  setup(o, { emit: t }) {
    const e = o, i = t, p = N(), n = e.id ?? p, s = P(() => {
      const c = [];
      for (const h of e.options) {
        const v = c[c.length - 1];
        v && v.group === h.group ? v.options.push(h) : c.push({ key: `${String(c.length)}:${h.group ?? ""}`, group: h.group, options: [h] });
      }
      return c;
    });
    function r(c) {
      const h = c.target, v = e.options.find((x) => String(x.value) === h.value), f = v ? v.value : h.value;
      i("update:modelValue", f), i("change", f);
    }
    return (c, h) => (a(), l("div", qe, [
      e.label ? (a(), l("label", {
        key: 0,
        for: V(n),
        class: "ui-select__label"
      }, [
        z(u(e.label) + " ", 1),
        e.required ? (a(), l("span", Pe, "*")) : _("", !0)
      ], 8, Se)) : _("", !0),
      d("div", Oe, [
        d("select", T({
          id: V(n),
          value: e.modelValue,
          disabled: e.disabled,
          required: e.required,
          "aria-invalid": !!e.error,
          class: ["ui-select__field", { "ui-select__field--error": !!e.error }]
        }, c.$attrs, { onChange: r }), [
          e.placeholder ? (a(), l("option", Re, u(e.placeholder), 1)) : _("", !0),
          (a(!0), l(B, null, M(s.value, (v) => (a(), l(B, {
            key: v.key
          }, [
            v.group ? (a(), l("optgroup", {
              key: 0,
              label: v.group
            }, [
              (a(!0), l(B, null, M(v.options, (f) => (a(), l("option", {
                key: f.value,
                value: f.value,
                disabled: f.disabled
              }, u(f.label), 9, Te))), 128))
            ], 8, Fe)) : (a(!0), l(B, { key: 1 }, M(v.options, (f) => (a(), l("option", {
              key: f.value,
              value: f.value,
              disabled: f.disabled
            }, u(f.label), 9, Ne))), 128))
          ], 64))), 128))
        ], 16, Ae),
        h[0] || (h[0] = d("span", {
          class: "ui-select__chevron",
          "aria-hidden": "true"
        }, "▾", -1))
      ]),
      e.error ? (a(), l("span", je, u(e.error), 1)) : e.hint ? (a(), l("span", De, u(e.hint), 1)) : _("", !0)
    ]));
  }
}), Da = /* @__PURE__ */ k(He, [["__scopeId", "data-v-ae5dcd79"]]), Ze = { class: "ui-search" }, Ke = ["value", "placeholder"], Xe = ["aria-label"], Ge = /* @__PURE__ */ $({
  __name: "UiSearchInput",
  props: {
    modelValue: { default: "" },
    placeholder: { default: "" },
    clearLabel: { default: "Очистить" }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, i = t;
    function p(n) {
      i("update:modelValue", n.target.value);
    }
    return (n, s) => (a(), l("div", Ze, [
      s[2] || (s[2] = d("span", {
        class: "ui-search__icon",
        "aria-hidden": "true"
      }, [
        d("svg", {
          width: "16",
          height: "16",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          d("circle", {
            cx: "11",
            cy: "11",
            r: "8"
          }),
          d("path", { d: "m21 21-4.3-4.3" })
        ])
      ], -1)),
      d("input", {
        class: "ui-search__field",
        type: "text",
        value: e.modelValue,
        placeholder: e.placeholder,
        onInput: p
      }, null, 40, Ke),
      e.modelValue ? (a(), l("button", {
        key: 0,
        type: "button",
        class: "ui-search__clear",
        "aria-label": e.clearLabel,
        onClick: s[0] || (s[0] = (r) => i("update:modelValue", ""))
      }, [...s[1] || (s[1] = [
        d("svg", {
          width: "14",
          height: "14",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "2.2",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, [
          d("path", { d: "M18 6 6 18M6 6l12 12" })
        ], -1)
      ])], 8, Xe)) : _("", !0)
    ]));
  }
}), Ha = /* @__PURE__ */ k(Ge, [["__scopeId", "data-v-788c599e"]]), Ye = ["aria-pressed", "disabled"], Je = {
  key: 0,
  class: "ui-chip__dot"
}, Qe = {
  key: 1,
  class: "ui-chip__count"
}, We = /* @__PURE__ */ $({
  __name: "UiFilterChip",
  props: {
    active: { type: Boolean, default: !1 },
    tone: { default: "brand" },
    dot: { type: Boolean, default: !1 },
    count: { default: void 0 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(o) {
    return (t, e) => (a(), l("button", {
      type: "button",
      class: C(["ui-chip", [`ui-chip--${o.tone}`, { "ui-chip--on": o.active }]]),
      "aria-pressed": o.active,
      disabled: o.disabled
    }, [
      o.dot ? (a(), l("span", Je)) : _("", !0),
      U(t.$slots, "default", {}, void 0, !0),
      o.count !== void 0 ? (a(), l("span", Qe, u(o.count), 1)) : _("", !0)
    ], 10, Ye));
  }
}), Za = /* @__PURE__ */ k(We, [["__scopeId", "data-v-581277c0"]]), et = {
  class: "ui-seg",
  role: "group"
}, tt = ["aria-pressed", "aria-label", "title", "onClick"], at = { key: 1 }, lt = /* @__PURE__ */ $({
  __name: "UiSegmented",
  props: {
    modelValue: {},
    options: {},
    iconOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, i = t;
    return (p, n) => (a(), l("div", et, [
      (a(!0), l(B, null, M(e.options, (s) => (a(), l("button", {
        key: s.value,
        type: "button",
        class: C(["ui-seg__btn", { "ui-seg__btn--on": e.modelValue === s.value, "ui-seg__btn--icon": e.iconOnly }]),
        "aria-pressed": e.modelValue === s.value,
        "aria-label": s.ariaLabel,
        title: s.ariaLabel,
        onClick: (r) => i("update:modelValue", s.value)
      }, [
        s.icon ? (a(), S(G(s.icon), {
          key: 0,
          size: e.iconOnly ? 16 : 13,
          "stroke-width": 1.75
        }, null, 8, ["size"])) : _("", !0),
        !e.iconOnly && s.label ? (a(), l("span", at, u(s.label), 1)) : _("", !0)
      ], 10, tt))), 128))
    ]));
  }
}), Ka = /* @__PURE__ */ k(lt, [["__scopeId", "data-v-24538077"]]), ot = { class: "ui-checklist" }, it = {
  key: 0,
  class: "ui-checklist__label"
}, st = {
  key: 0,
  class: "ui-checklist__count"
}, nt = ["placeholder"], rt = ["checked", "onChange"], ut = { key: 0 }, dt = {
  key: 0,
  class: "ui-checklist__empty"
}, ct = /* @__PURE__ */ $({
  __name: "UiCheckList",
  props: {
    modelValue: {},
    options: {},
    label: { default: "" },
    searchable: { type: Boolean, default: !1 },
    searchPlaceholder: { default: "" },
    emptyText: { default: "—" }
  },
  emits: ["update:modelValue"],
  setup(o, { emit: t }) {
    const e = o, i = t, p = I(""), n = P(() => {
      const r = p.value.trim().toLowerCase();
      return r ? e.options.filter((c) => c.label.toLowerCase().includes(r)) : e.options;
    });
    function s(r) {
      const c = e.modelValue.includes(r) ? e.modelValue.filter((h) => h !== r) : [...e.modelValue, r];
      i("update:modelValue", c);
    }
    return (r, c) => (a(), l("div", ot, [
      e.label ? (a(), l("span", it, [
        z(u(e.label) + " ", 1),
        e.modelValue.length ? (a(), l("span", st, "· " + u(e.modelValue.length), 1)) : _("", !0)
      ])) : _("", !0),
      e.searchable ? ae((a(), l("input", {
        key: 1,
        "onUpdate:modelValue": c[0] || (c[0] = (h) => p.value = h),
        type: "text",
        class: "ui-checklist__search",
        placeholder: e.searchPlaceholder
      }, null, 8, nt)), [
        [le, p.value]
      ]) : _("", !0),
      d("div", {
        class: C(["ui-checklist__list", { "ui-checklist__list--scroll": e.searchable }])
      }, [
        (a(!0), l(B, null, M(n.value, (h) => (a(), l("label", {
          key: h.value,
          class: "ui-checklist__item"
        }, [
          d("input", {
            type: "checkbox",
            checked: e.modelValue.includes(h.value),
            onChange: (v) => s(h.value)
          }, null, 40, rt),
          d("span", null, [
            h.prefix ? (a(), l("b", ut, u(h.prefix) + ":", 1)) : _("", !0),
            z(" " + u(h.label), 1)
          ])
        ]))), 128)),
        n.value.length ? _("", !0) : (a(), l("p", dt, u(e.emptyText), 1))
      ], 2)
    ]));
  }
}), Xa = /* @__PURE__ */ k(ct, [["__scopeId", "data-v-8b6a509c"]]), _t = /* @__PURE__ */ $({
  __name: "UiBadge",
  props: {
    status: {},
    label: {},
    variant: {}
  },
  setup(o) {
    const t = o, e = {
      draft: { label: "Черновик", variant: "gray" },
      pending: { label: "Ожидает", variant: "yellow" },
      in_progress: { label: "В процессе", variant: "blue" },
      completed: { label: "Завершено", variant: "green" },
      cancelled: { label: "Отменено", variant: "red" },
      failed: { label: "Не пройдено", variant: "red" },
      registered: { label: "Зарегистрирован", variant: "primary" },
      published: { label: "Опубликовано", variant: "green" },
      rejected: { label: "Отклонено", variant: "red" },
      confirmed: { label: "Подтверждено", variant: "green" }
    }, i = P(() => {
      var n;
      return t.label ? t.label : t.status ? ((n = e[t.status]) == null ? void 0 : n.label) ?? t.status : "";
    }), p = P(() => {
      var n;
      return t.variant ? t.variant : t.status ? ((n = e[t.status]) == null ? void 0 : n.variant) ?? "gray" : "gray";
    });
    return (n, s) => (a(), l("span", {
      class: C(["ui-badge", `ui-badge--${p.value}`])
    }, u(i.value), 3));
  }
}), Ga = /* @__PURE__ */ k(_t, [["__scopeId", "data-v-d2118f3f"]]), pt = {
  key: 0,
  class: "ui-banner__title"
}, ht = /* @__PURE__ */ $({
  __name: "UiBanner",
  props: {
    type: { default: "info" },
    title: {}
  },
  setup(o) {
    return (t, e) => (a(), l("div", {
      class: C(["ui-banner", `ui-banner--${t.$props.type}`]),
      role: "alert"
    }, [
      t.$props.title ? (a(), l("strong", pt, u(t.$props.title), 1)) : _("", !0),
      U(t.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Ya = /* @__PURE__ */ k(ht, [["__scopeId", "data-v-b928dcef"]]), ft = {
  key: 0,
  class: "ui-loading__spinner",
  "aria-hidden": "true"
}, mt = { class: "ui-loading__text" }, vt = /* @__PURE__ */ $({
  __name: "UiLoading",
  props: {
    size: { default: "md" },
    text: { default: "Загрузка..." },
    spinner: { type: Boolean, default: !0 }
  },
  setup(o) {
    return (t, e) => (a(), l("div", {
      class: C(["ui-loading", `ui-loading--${t.$props.size}`]),
      role: "status",
      "aria-live": "polite"
    }, [
      t.$props.spinner ? (a(), l("span", ft)) : _("", !0),
      d("span", mt, u(t.$props.text), 1)
    ], 2));
  }
}), Ja = /* @__PURE__ */ k(vt, [["__scopeId", "data-v-6c00dedd"]]), bt = { class: "ui-empty" }, yt = {
  key: 0,
  class: "ui-empty__icon",
  "aria-hidden": "true"
}, gt = {
  key: 1,
  class: "ui-empty__title"
}, $t = {
  key: 2,
  class: "ui-empty__message"
}, kt = {
  key: 3,
  class: "ui-empty__actions"
}, wt = /* @__PURE__ */ $({
  __name: "UiEmptyState",
  props: {
    icon: { default: "📋" },
    title: { default: "" },
    message: { default: "Ничего не найдено" }
  },
  setup(o) {
    return (t, e) => (a(), l("div", bt, [
      t.$props.icon ? (a(), l("div", yt, u(t.$props.icon), 1)) : _("", !0),
      t.$props.title ? (a(), l("h3", gt, u(t.$props.title), 1)) : _("", !0),
      t.$props.message ? (a(), l("p", $t, u(t.$props.message), 1)) : _("", !0),
      t.$slots.default ? (a(), l("div", kt, [
        U(t.$slots, "default", {}, void 0, !0)
      ])) : _("", !0)
    ]));
  }
}), Qa = /* @__PURE__ */ k(wt, [["__scopeId", "data-v-9b83cfe9"]]), Ct = { class: "ui-map" }, xt = { class: "ui-map__toolbar" }, It = ["aria-label"], Ut = { class: "ui-map__zoom" }, Vt = ["aria-label"], Bt = {
  key: 0,
  class: "ui-map__hint"
}, Lt = { class: "ui-map__viewport" }, zt = ["src"], Et = {
  key: 1,
  class: "ui-map__noplan"
}, Mt = ["title", "onClick", "onPointerdown"], qt = {
  key: 1,
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, St = { class: "ui-marker__label" }, Pt = /* @__PURE__ */ $({
  __name: "UiVenueMap",
  props: {
    planSrc: {},
    aspect: {},
    markers: {},
    icons: { default: () => ({}) },
    labels: { default: () => ({}) },
    editable: { type: Boolean, default: !1 },
    selectedId: { default: null }
  },
  emits: ["place", "move", "select"],
  setup(o, { emit: t }) {
    const e = o, i = t, p = P(() => ({
      zoomIn: e.labels.zoomIn ?? "Увеличить",
      zoomOut: e.labels.zoomOut ?? "Уменьшить",
      zoomReset: e.labels.zoomReset ?? "Сбросить масштаб",
      noPlan: e.labels.noPlan ?? "План не загружен",
      hint: e.labels.hint
    })), n = I(1), s = I(!1);
    Y(
      () => e.planSrc,
      () => {
        s.value = !1;
      }
    );
    const r = I(null), c = I(null), h = P(() => ({ aspectRatio: String(e.aspect ?? 16 / 10) }));
    function v(g) {
      var R;
      const m = (R = r.value) == null ? void 0 : R.getBoundingClientRect();
      if (!m) return null;
      const y = (g.clientX - m.left) / m.width, E = (g.clientY - m.top) / m.height;
      return y < 0 || y > 1 || E < 0 || E > 1 ? null : { x: Number(y.toFixed(4)), y: Number(E.toFixed(4)) };
    }
    function f(g) {
      if (!e.editable || c.value) return;
      const m = v(g);
      m && i("place", m);
    }
    function x(g, m) {
      e.editable && (g.stopPropagation(), c.value = m, g.target.setPointerCapture(g.pointerId));
    }
    function b(g) {
      if (!c.value) return;
      const m = v(g);
      m && i("move", { id: c.value, shape: m });
    }
    function w() {
      window.setTimeout(() => {
        c.value = null;
      }, 0);
    }
    return (g, m) => (a(), l("div", Ct, [
      d("div", xt, [
        d("button", {
          type: "button",
          "aria-label": p.value.zoomOut,
          onClick: m[0] || (m[0] = (y) => n.value = Math.max(1, n.value - 0.25))
        }, " − ", 8, It),
        d("span", Ut, u(Math.round(n.value * 100)) + "%", 1),
        d("button", {
          type: "button",
          "aria-label": p.value.zoomIn,
          onClick: m[1] || (m[1] = (y) => n.value = Math.min(4, n.value + 0.25))
        }, " + ", 8, Vt),
        d("button", {
          type: "button",
          class: "ui-map__reset",
          onClick: m[2] || (m[2] = (y) => n.value = 1)
        }, u(p.value.zoomReset), 1),
        p.value.hint ? (a(), l("span", Bt, u(p.value.hint), 1)) : _("", !0)
      ]),
      d("div", Lt, [
        d("div", {
          ref_key: "surface",
          ref: r,
          class: C(["ui-map__surface", { "ui-map__surface--editable": e.editable }]),
          style: O({ ...h.value, width: `${n.value * 100}%` }),
          onClick: f,
          onPointermove: b,
          onPointerup: w
        }, [
          e.planSrc && !s.value ? (a(), l("img", {
            key: 0,
            src: e.planSrc,
            alt: "",
            class: "ui-map__plan",
            onError: m[3] || (m[3] = (y) => s.value = !0)
          }, null, 40, zt)) : (a(), l("div", Et, u(p.value.noPlan), 1)),
          (a(!0), l(B, null, M(e.markers, (y) => (a(), l("button", {
            key: y.id,
            type: "button",
            class: C(["ui-marker", {
              "ui-marker--active": y.id === e.selectedId,
              "ui-marker--restricted": y.restricted,
              "ui-marker--highlighted": y.highlighted
            }]),
            style: O({ left: `${y.shape.x * 100}%`, top: `${y.shape.y * 100}%` }),
            title: y.title,
            onClick: J((E) => i("select", y.id), ["stop"]),
            onPointerdown: (E) => x(E, y.id)
          }, [
            e.icons[y.kind] ? (a(), S(G(e.icons[y.kind]), {
              key: 0,
              size: 14,
              "stroke-width": 2,
              "aria-hidden": "true"
            })) : (a(), l("svg", qt, [...m[4] || (m[4] = [
              d("path", { d: "M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" }, null, -1),
              d("circle", {
                cx: "12",
                cy: "10",
                r: "3"
              }, null, -1)
            ])])),
            d("span", St, u(y.title), 1)
          ], 46, Mt))), 128))
        ], 38)
      ])
    ]));
  }
}), Wa = /* @__PURE__ */ k(Pt, [["__scopeId", "data-v-4ee25ba4"]]), Ot = ["aria-labelledby"], At = { class: "ui-modal__heading" }, Rt = {
  id: "ui-modal-title",
  class: "ui-modal__title"
}, Ft = {
  key: 0,
  class: "ui-modal__subtitle"
}, Tt = ["aria-label", "title"], Nt = { class: "ui-modal__body" }, jt = {
  key: 1,
  class: "ui-modal__footer"
}, Dt = /* @__PURE__ */ $({
  __name: "UiModal",
  props: {
    modelValue: { type: Boolean, default: !1 },
    title: {},
    subtitle: {},
    size: { default: "md" },
    closeOnOverlay: { type: Boolean, default: !0 },
    closeOnEsc: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !1 },
    closeLabel: { default: "Закрыть" }
  },
  emits: ["update:modelValue", "close"],
  setup(o, { emit: t }) {
    const e = o, i = t;
    function p() {
      i("update:modelValue", !1), i("close");
    }
    function n() {
      e.closeOnOverlay && p();
    }
    function s(r) {
      r.key === "Escape" && e.closeOnEsc && p();
    }
    return Y(
      () => e.modelValue,
      (r) => {
        typeof window > "u" || (r ? (document.addEventListener("keydown", s), document.body.style.overflow = "hidden") : (document.removeEventListener("keydown", s), document.body.style.overflow = ""));
      },
      { immediate: !0 }
    ), D(() => {
      typeof window < "u" && (document.removeEventListener("keydown", s), document.body.style.overflow = "");
    }), (r, c) => (a(), S(H, { to: "body" }, [
      q(oe, { name: "ui-modal" }, {
        default: L(() => [
          e.modelValue ? (a(), l("div", {
            key: 0,
            class: "ui-modal-overlay",
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": e.title ? "ui-modal-title" : void 0,
            onClick: J(n, ["self"])
          }, [
            d("div", {
              class: C(["ui-modal", `ui-modal--${e.size}`])
            }, [
              e.title || r.$slots.header || e.closable ? (a(), l("div", {
                key: 0,
                class: C(["ui-modal__header", { "ui-modal__header--closable": e.closable }])
              }, [
                d("div", At, [
                  U(r.$slots, "header", {}, () => [
                    d("h3", Rt, u(e.title), 1),
                    e.subtitle ? (a(), l("p", Ft, u(e.subtitle), 1)) : _("", !0)
                  ], !0)
                ]),
                e.closable ? (a(), l("button", {
                  key: 0,
                  type: "button",
                  class: "ui-modal__close",
                  "aria-label": e.closeLabel,
                  title: e.closeLabel,
                  onClick: p
                }, [...c[0] || (c[0] = [
                  d("svg", {
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "aria-hidden": "true"
                  }, [
                    d("path", { d: "M18 6 6 18M6 6l12 12" })
                  ], -1)
                ])], 8, Tt)) : _("", !0)
              ], 2)) : _("", !0),
              d("div", Nt, [
                U(r.$slots, "default", {}, void 0, !0)
              ]),
              r.$slots.footer ? (a(), l("div", jt, [
                U(r.$slots, "footer", {}, void 0, !0)
              ])) : _("", !0)
            ], 2)
          ], 8, Ot)) : _("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Ht = /* @__PURE__ */ k(Dt, [["__scopeId", "data-v-ba2e0f0b"]]), Zt = {
  key: 0,
  class: "ui-confirm__message"
}, Kt = /* @__PURE__ */ $({
  __name: "UiConfirm",
  props: {
    controller: {}
  },
  setup(o) {
    const t = o;
    function e(i) {
      i || t.controller.cancel();
    }
    return (i, p) => (a(), S(Ht, {
      "model-value": t.controller.open.value,
      title: t.controller.options.value.title,
      size: "sm",
      "onUpdate:modelValue": e
    }, {
      footer: L(() => [
        q(F, {
          variant: "ghost",
          onClick: t.controller.cancel
        }, {
          default: L(() => [
            z(u(t.controller.options.value.cancelLabel ?? "Отмена"), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        q(F, {
          variant: t.controller.options.value.danger ? "danger" : "primary",
          onClick: t.controller.confirm
        }, {
          default: L(() => [
            z(u(t.controller.options.value.confirmLabel ?? "Подтвердить"), 1)
          ]),
          _: 1
        }, 8, ["variant", "onClick"])
      ]),
      default: L(() => [
        t.controller.options.value.message ? (a(), l("p", Zt, u(t.controller.options.value.message), 1)) : _("", !0)
      ]),
      _: 1
    }, 8, ["model-value", "title"]));
  }
}), el = /* @__PURE__ */ k(Kt, [["__scopeId", "data-v-81ebeee2"]]), Xt = { class: "ui-card" }, Gt = {
  key: 0,
  class: "ui-card__header"
}, Yt = { class: "ui-card__title-wrap" }, Jt = {
  key: 0,
  class: "ui-card__title"
}, Qt = {
  key: 1,
  class: "ui-card__subtitle"
}, Wt = {
  key: 0,
  class: "ui-card__actions"
}, ea = /* @__PURE__ */ $({
  __name: "UiCard",
  props: {
    title: {},
    subtitle: {},
    noPadding: { type: Boolean, default: !1 }
  },
  setup(o) {
    return (t, e) => (a(), l("section", Xt, [
      o.title || t.$slots.actions || o.subtitle ? (a(), l("header", Gt, [
        d("div", Yt, [
          o.title ? (a(), l("h2", Jt, u(o.title), 1)) : _("", !0),
          o.subtitle ? (a(), l("p", Qt, u(o.subtitle), 1)) : _("", !0)
        ]),
        t.$slots.actions ? (a(), l("div", Wt, [
          U(t.$slots, "actions", {}, void 0, !0)
        ])) : _("", !0)
      ])) : _("", !0),
      d("div", {
        class: C(["ui-card__body", { "ui-card__body--flush": o.noPadding }])
      }, [
        U(t.$slots, "default", {}, void 0, !0)
      ], 2)
    ]));
  }
}), tl = /* @__PURE__ */ k(ea, [["__scopeId", "data-v-dfbb4479"]]);
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ta = (o) => {
  for (const t in o)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
  return !1;
};
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const K = (o) => o === "";
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aa = (...o) => o.filter((t, e, i) => !!t && t.trim() !== "" && i.indexOf(t) === e).join(" ").trim();
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const X = (o) => o.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const la = (o) => o.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, e, i) => i ? i.toUpperCase() : e.toLowerCase()
);
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oa = (o) => {
  const t = la(o);
  return t.charAt(0).toUpperCase() + t.slice(1);
};
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var A = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ia = ({
  name: o,
  iconNode: t,
  absoluteStrokeWidth: e,
  "absolute-stroke-width": i,
  strokeWidth: p,
  "stroke-width": n,
  size: s = A.width,
  color: r = A.stroke,
  ...c
}, { slots: h }) => j(
  "svg",
  {
    ...A,
    ...c,
    width: s,
    height: s,
    stroke: r,
    "stroke-width": K(e) || K(i) || e === !0 || i === !0 ? Number(p || n || A["stroke-width"]) * 24 / Number(s) : p || n || A["stroke-width"],
    class: aa(
      "lucide",
      c.class,
      ...o ? [`lucide-${X(oa(o))}-icon`, `lucide-${X(o)}`] : ["lucide-icon"]
    ),
    ...!h.default && !ta(c) && { "aria-hidden": "true" }
  },
  [...t.map((v) => j(...v)), ...h.default ? [h.default()] : []]
);
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Z = (o, t) => (e, { slots: i, attrs: p }) => j(
  ia,
  {
    ...p,
    ...e,
    iconNode: t,
    name: o
  },
  i
);
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sa = Z("columns-3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const na = Z("ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
/**
 * @license lucide-vue-next v1.0.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ra = Z("x", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), ua = ["aria-expanded"], da = /* @__PURE__ */ $({
  __name: "UiRowMenu",
  setup(o) {
    const t = I(!1), e = I(null), i = I(null), p = I({ top: 0, left: 0 });
    function n() {
      const f = e.value, x = i.value;
      if (!f || !x) return;
      const b = f.getBoundingClientRect(), w = x.getBoundingClientRect(), g = 4, y = window.innerHeight - b.bottom < w.height + g && b.top > w.height + g ? b.top - w.height - g : b.bottom + g, E = Math.max(8, Math.min(b.right - w.width, window.innerWidth - w.width - 8));
      p.value = { top: y, left: E };
    }
    async function s() {
      t.value = !t.value, t.value && (await W(), n());
    }
    function r() {
      t.value = !1;
    }
    function c(f) {
      var b, w;
      const x = f.target;
      (b = e.value) != null && b.contains(x) || (w = i.value) != null && w.contains(x) || r();
    }
    function h(f) {
      f.key === "Escape" && r();
    }
    function v() {
      t.value && r();
    }
    return Q(() => {
      document.addEventListener("click", c), document.addEventListener("keydown", h), window.addEventListener("scroll", v, !0), window.addEventListener("resize", v);
    }), D(() => {
      document.removeEventListener("click", c), document.removeEventListener("keydown", h), window.removeEventListener("scroll", v, !0), window.removeEventListener("resize", v);
    }), (f, x) => (a(), l("div", {
      ref_key: "root",
      ref: e,
      class: "ui-row-menu"
    }, [
      d("button", {
        type: "button",
        class: C(["ui-row-menu__trigger", { "ui-row-menu__trigger--on": t.value }]),
        "aria-expanded": t.value,
        "aria-haspopup": "menu",
        "aria-label": "Ещё действия",
        onClick: s
      }, [
        q(V(na), {
          size: 16,
          "stroke-width": 1.75,
          "aria-hidden": "true"
        })
      ], 10, ua),
      (a(), S(H, { to: "body" }, [
        t.value ? (a(), l("div", {
          key: 0,
          ref_key: "list",
          ref: i,
          class: "ui-row-menu__list",
          role: "menu",
          style: O({ top: `${p.value.top}px`, left: `${p.value.left}px` }),
          onClick: r
        }, [
          U(f.$slots, "default", {}, void 0, !0)
        ], 4)) : _("", !0)
      ]))
    ], 512));
  }
}), al = /* @__PURE__ */ k(da, [["__scopeId", "data-v-61411471"]]), ca = /* @__PURE__ */ $({
  __name: "UiPopover",
  props: {
    width: { default: "18rem" },
    align: { default: "right" }
  },
  setup(o, { expose: t }) {
    const e = o, i = I(!1), p = I(null), n = I(null), s = I({ top: 0, left: 0 });
    function r() {
      const b = p.value, w = n.value;
      if (!b || !w) return;
      const g = b.getBoundingClientRect(), m = w.getBoundingClientRect(), y = 4, R = window.innerHeight - g.bottom < m.height + y && g.top > m.height + y ? g.top - m.height - y : g.bottom + y, ee = e.align === "right" ? g.right - m.width : g.left, te = Math.max(8, Math.min(ee, window.innerWidth - m.width - 8));
      s.value = { top: R, left: te };
    }
    async function c() {
      var b, w;
      i.value = !i.value, i.value && (await W(), r(), (w = (b = n.value) == null ? void 0 : b.querySelector("input, select, textarea, button")) == null || w.focus());
    }
    function h() {
      i.value = !1;
    }
    function v(b) {
      var g, m;
      const w = b.target;
      (g = p.value) != null && g.contains(w) || (m = n.value) != null && m.contains(w) || h();
    }
    function f(b) {
      b.key === "Escape" && h();
    }
    function x(b) {
      var w;
      i.value && ((w = n.value) != null && w.contains(b.target) || h());
    }
    return Q(() => {
      document.addEventListener("click", v), document.addEventListener("keydown", f), window.addEventListener("scroll", x, !0), window.addEventListener("resize", h);
    }), D(() => {
      document.removeEventListener("click", v), document.removeEventListener("keydown", f), window.removeEventListener("scroll", x, !0), window.removeEventListener("resize", h);
    }), t({ close: h }), (b, w) => (a(), l("div", {
      ref_key: "root",
      ref: p,
      class: "ui-popover"
    }, [
      U(b.$slots, "trigger", {
        toggle: c,
        open: i.value
      }, void 0, !0),
      (a(), S(H, { to: "body" }, [
        i.value ? (a(), l("div", {
          key: 0,
          ref_key: "panel",
          ref: n,
          class: "ui-popover__panel",
          role: "dialog",
          style: O({ top: `${s.value.top}px`, left: `${s.value.left}px`, width: e.width })
        }, [
          U(b.$slots, "default", { close: h }, void 0, !0)
        ], 4)) : _("", !0)
      ]))
    ], 512));
  }
}), _a = /* @__PURE__ */ k(ca, [["__scopeId", "data-v-35a418e7"]]), pa = { class: "ui-column-picker" }, ha = {
  key: 0,
  class: "ui-column-picker__group"
}, fa = { class: "ui-column-picker__item" }, ma = ["checked", "onChange"], ll = /* @__PURE__ */ $({
  __name: "UiColumnPicker",
  props: {
    columns: {},
    visible: {},
    label: { default: "Колонки" },
    resetLabel: { default: "Как было" }
  },
  emits: ["toggle", "reset"],
  setup(o, { emit: t }) {
    const e = o, i = t;
    function p(n) {
      var r, c;
      const s = (r = e.columns[n]) == null ? void 0 : r.group;
      return !!s && s !== ((c = e.columns[n - 1]) == null ? void 0 : c.group);
    }
    return (n, s) => (a(), S(_a, { width: "17rem" }, {
      trigger: L(({ toggle: r, open: c }) => [
        q(F, {
          variant: "ghost",
          "aria-expanded": c,
          onClick: r
        }, {
          default: L(() => [
            q(V(sa), {
              size: 15,
              "stroke-width": 1.75,
              "aria-hidden": "true"
            }),
            z(" " + u(e.label), 1)
          ]),
          _: 1
        }, 8, ["aria-expanded", "onClick"])
      ]),
      default: L(() => [
        d("div", pa, [
          (a(!0), l(B, null, M(e.columns, (r, c) => (a(), l(B, {
            key: r.id
          }, [
            p(c) ? (a(), l("p", ha, u(r.group), 1)) : _("", !0),
            d("label", fa, [
              d("input", {
                type: "checkbox",
                checked: e.visible.includes(r.id),
                onChange: (h) => i("toggle", r.id)
              }, null, 40, ma),
              d("span", null, u(r.label), 1)
            ])
          ], 64))), 128)),
          d("button", {
            type: "button",
            class: "ui-column-picker__reset",
            onClick: s[0] || (s[0] = (r) => i("reset"))
          }, u(e.resetLabel), 1)
        ])
      ]),
      _: 1
    }));
  }
}), va = {
  key: 0,
  class: "ui-active-filters"
}, ba = { class: "ui-active-filters__title" }, ya = ["title", "onClick"], ga = { class: "ui-active-filters__label" }, $a = { class: "ui-active-filters__value" }, ka = /* @__PURE__ */ $({
  __name: "UiActiveFilters",
  props: {
    filters: {},
    title: { default: "Отобрано:" },
    clearLabel: { default: "Сбросить все" }
  },
  emits: ["remove", "clear"],
  setup(o, { emit: t }) {
    const e = o, i = t;
    return (p, n) => e.filters.length ? (a(), l("div", va, [
      d("span", ba, u(e.title), 1),
      (a(!0), l(B, null, M(e.filters, (s) => (a(), l("button", {
        key: s.id,
        type: "button",
        class: "ui-active-filters__chip",
        title: `Снять: ${s.label}`,
        onClick: (r) => i("remove", s.id)
      }, [
        d("span", ga, u(s.label), 1),
        d("span", $a, u(s.value), 1),
        q(V(ra), {
          size: 13,
          "stroke-width": 2,
          "aria-hidden": "true"
        })
      ], 8, ya))), 128)),
      e.filters.length > 1 ? (a(), S(F, {
        key: 0,
        variant: "ghost",
        onClick: n[0] || (n[0] = (s) => i("clear"))
      }, {
        default: L(() => [
          z(u(e.clearLabel), 1)
        ]),
        _: 1
      })) : _("", !0)
    ])) : _("", !0);
  }
}), ol = /* @__PURE__ */ k(ka, [["__scopeId", "data-v-fead25f0"]]), wa = ["disabled"], Ca = /* @__PURE__ */ $({
  __name: "UiMenuItem",
  props: {
    danger: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  setup(o) {
    return (t, e) => (a(), l("button", {
      type: "button",
      role: "menuitem",
      class: C(["ui-menu-item", { "ui-menu-item--danger": o.danger }]),
      disabled: o.disabled
    }, [
      U(t.$slots, "default", {}, void 0, !0)
    ], 10, wa));
  }
}), il = /* @__PURE__ */ k(Ca, [["__scopeId", "data-v-d40f0c56"]]), xa = /* @__PURE__ */ $({
  __name: "UiIconChip",
  props: {
    tone: { default: "primary" },
    size: { default: 40 }
  },
  setup(o) {
    return (t, e) => (a(), l("span", {
      class: C(["ui-icon-chip", `ui-icon-chip--${o.tone}`]),
      style: O({ width: `${o.size}px`, height: `${o.size}px` })
    }, [
      U(t.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}), Ia = /* @__PURE__ */ k(xa, [["__scopeId", "data-v-02e14dcd"]]), Ua = /* @__PURE__ */ $({
  __name: "UiSkeleton",
  props: {
    width: { default: "100%" },
    height: { default: "14px" },
    circle: { type: Boolean, default: !1 }
  },
  setup(o) {
    return (t, e) => (a(), l("span", {
      class: C(["ui-skeleton", { "ui-skeleton--circle": o.circle }]),
      style: O({ width: o.width, height: o.height }),
      "aria-hidden": "true"
    }, null, 6));
  }
}), sl = /* @__PURE__ */ k(Ua, [["__scopeId", "data-v-c4a6d697"]]), Va = { class: "ui-stat" }, Ba = { class: "ui-stat__top" }, La = {
  key: 0,
  class: "ui-stat__delta"
}, za = { class: "ui-stat__value" }, Ea = { class: "ui-stat__label" }, Ma = /* @__PURE__ */ $({
  __name: "UiStat",
  props: {
    value: {},
    label: {},
    tone: { default: "primary" },
    delta: {}
  },
  setup(o) {
    return (t, e) => (a(), l("div", Va, [
      d("div", Ba, [
        q(Ia, {
          tone: o.tone,
          size: 32
        }, {
          default: L(() => [
            U(t.$slots, "icon", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["tone"]),
        o.delta ? (a(), l("span", La, u(o.delta), 1)) : _("", !0)
      ]),
      d("span", za, u(o.value), 1),
      d("span", Ea, u(o.label), 1)
    ]));
  }
}), nl = /* @__PURE__ */ k(Ma, [["__scopeId", "data-v-a8071ff2"]]), qa = { class: "page-header" }, Sa = { class: "page-header__main" }, Pa = { class: "page-header__title" }, Oa = {
  key: 0,
  class: "page-header__subtitle"
}, Aa = {
  key: 0,
  class: "page-header__actions"
}, Ra = /* @__PURE__ */ $({
  __name: "PageHeader",
  props: {
    title: {},
    subtitle: {}
  },
  setup(o) {
    return (t, e) => (a(), l("header", qa, [
      d("div", Sa, [
        d("h1", Pa, u(o.title), 1),
        o.subtitle ? (a(), l("p", Oa, u(o.subtitle), 1)) : _("", !0)
      ]),
      t.$slots.default ? (a(), l("div", Aa, [
        U(t.$slots, "default", {}, void 0, !0)
      ])) : _("", !0)
    ]));
  }
}), rl = /* @__PURE__ */ k(Ra, [["__scopeId", "data-v-e3bc3040"]]);
function ul() {
  const o = I(!1), t = I({ title: "" });
  let e = null;
  function i(n) {
    o.value = !1, e == null || e(n), e = null;
  }
  function p(n) {
    return t.value = n, o.value = !0, new Promise((s) => {
      e = s;
    });
  }
  return {
    open: o,
    options: t,
    ask: p,
    confirm: () => i(!0),
    cancel: () => i(!1)
  };
}
export {
  rl as PageHeader,
  ol as UiActiveFilters,
  Ga as UiBadge,
  Ya as UiBanner,
  F as UiButton,
  tl as UiCard,
  Xa as UiCheckList,
  ll as UiColumnPicker,
  el as UiConfirm,
  Qa as UiEmptyState,
  ja as UiFileInput,
  Za as UiFilterChip,
  Ia as UiIconChip,
  Ta as UiInput,
  Ja as UiLoading,
  il as UiMenuItem,
  Ht as UiModal,
  _a as UiPopover,
  al as UiRowMenu,
  Ha as UiSearchInput,
  Ka as UiSegmented,
  Da as UiSelect,
  sl as UiSkeleton,
  nl as UiStat,
  Na as UiTextarea,
  Wa as UiVenueMap,
  ul as useConfirm
};
//# sourceMappingURL=arpm-ui.js.map
